import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class ControlNameBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.controlName = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let name = ko.unwrap(valueAccessor());

                $(element).addClass('c-control');
                $(element).addClass('c-' + name);
            }
        };
    }
}